export * from '../survey/survey-player/survey-player.component';
export * from './survey-widgets/default-svg';
export * from './survey-widgets/svgmapwidget';
export * from './survey-widgets/custom-widget';
